// Multi-language translations for FeelAtHomeNow website

export const translations = {
  de: {
    // Navigation
    nav: {
      home: "Startseite",
      apartments: "Wohnungen",
      rooms: "WG-Zimmer",
      blog: "Blog",
      forCompanies: "Für Unternehmen",
      forPropertyManagers: "Für Immobilienverwalter",
      about: "Über uns",
      contact: "Kontakt",
      ctaRooms: "WG-Zimmer ansehen",
    },

    // Hero Section — Zürich-Refokus + All-in-Versprechen (R2.4/H3, Wortlaut aus design-reference/startseite.html)
    hero: {
      headline: "Möblierte WG-Zimmer & Wohnungen in Zürich",
      subheadline: "Einziehen und ankommen — Möbel, WLAN und Nebenkosten sind schon drin. Flexible Verträge ab 3 Monaten.",
    },

    // Services Section
    services: {
      title: "Unsere Wohnlösungen",
      subtitle: "Professionelle und flexible Unterkünfte in der Schweiz",
      service1Title: "Ganze Wohnungen",
      service1Desc: "Komplett möblierte Apartments für Geschäftsreisende und Professionals",
      service2Title: "Möblierte WG-Zimmer",
      service2Desc: "Privates Zimmer in Shared Living — perfekt für Expats und junge Professionals",
      service3Title: "Für Unternehmen",
      service3Desc: "Flexible Wohnlösungen für entsendete Mitarbeitende und Projektteams",
    },

    // Homepage — Wohnen bei FeelAtHomeNow (nur freigegebene USPs, Regel 14).
    // R4F/F6: „Toplage Seefeld" + „Rooftop-Terrasse" gestrichen — gelten
    // nicht für alle Objekte (Inhaber-Entscheid).
    homeUsps: {
      label: 'Warum FeelAtHomeNow',
      title: 'Wohnen bei FeelAtHomeNow',
      intro: 'Mit langjähriger Vermietungserfahrung bereiten wir jedes Zimmer so vor, dass Sie nur noch ankommen müssen.',
      usp1Title: 'Voll möbliert',
      usp1Desc: 'Bett, Schrank, Schreibtisch, Küche — einziehen und ankommen.',
      usp2Title: 'Anmeldung möglich',
      usp2Desc: 'Offizielle Anmeldung beim Kreisbüro an jeder Adresse möglich.',
      usp3Title: 'Internationale Community',
      usp3Desc: 'Mitbewohnende aus aller Welt, Deutsch und Englisch im Alltag.',
      usp4Title: 'Video-Besichtigung',
      usp4Desc: 'Besichtigung vor Ort oder bequem per Video — auch aus dem Ausland.',
    },

    // Homepage — FAQ
    homeFaq: {
      label: 'Häufige Fragen',
      title: 'FAQ — Alles rund um möbliertes Wohnen',
      subtitle: 'Antworten auf die wichtigsten Fragen zu WG-Zimmern, Wohnungen und Co-Living in der Schweiz',
      q1: 'Wie läuft die Bewerbung für ein WG-Zimmer ab?',
      a1: 'Sie wählen ein WG-Zimmer in Zürich oder einer anderen Stadt auf unserer Website aus, füllen das Bewerbungsformular aus und erhalten innerhalb von 24 Stunden eine Rückmeldung. Nach einem kurzen Kennenlerngespräch können Sie direkt einziehen.',
      q2: 'Was kostet ein möbliertes WG-Zimmer in Zürich?',
      a2: 'Die Monatsmiete für ein möbliertes WG-Zimmer in Zürich liegt je nach Lage und Zimmergrösse zwischen CHF 900 und CHF 2\'100 pro Monat. Im Preis sind Nebenkosten, Internet und die Nutzung der Gemeinschaftsräume enthalten.',
      q3: 'Welche Vorteile bieten Business Apartments für Unternehmen?',
      a3: 'Business Apartments in Zürich und der Schweiz bieten Unternehmen eine flexible, sofort verfügbare Wohnlösung für entsendete Mitarbeitende. Alles ist inklusive — von der Einrichtung über Internet bis zu den Nebenkosten. Das spart Ihrem HR-Team Zeit und Aufwand.',
      q4: 'In welchen Städten ist FeelAtHomeNow verfügbar?',
      a4: 'Wir bieten möblierte WG-Zimmer und Wohnungen in Zürich, Basel, Bern und Genf sowie weiteren Standorten in der Schweiz. Unser Angebot wächst stetig — kontaktieren Sie uns für aktuelle Verfügbarkeiten.',
      q5: 'Wie kurzfristig kann ich einziehen?',
      a5: 'Dank unserer bezugsfertigen Wohnungen ist ein Einzug oft innerhalb weniger Tage möglich. In dringenden Fällen können wir sogar einen Einzug am selben Tag organisieren.',
      q6: 'Was ist im Mietpreis inbegriffen?',
      a6: 'Im Mietpreis sind die komplette Möblierung, Nebenkosten, Highspeed-Internet und ein persönlicher Ansprechpartner enthalten. Sie benötigen nur noch Ihren Koffer — den Rest erledigen wir.',
      q7: 'Wie lange ist die Kündigungsfrist?',
      a7: 'Die Mindestmietdauer beträgt 3 Monate. Nach Ablauf der Mindestmietdauer gilt eine Kündigungsfrist von 2 Monaten. Wer von Anfang an nur 3 Monate bleiben möchte, kann einen befristeten Aufenthalt über 3 Monate vereinbaren.',
    },

    // Startseite v2 — Hero (SearchModule, TrustRow ohne Rating, MiniListingCard)
    homeHero: {
      segmentAria: 'Angebotstyp wählen',
      segmentRoom: 'WG-Zimmer',
      segmentApartment: 'Wohnung',
      cityLabel: 'Stadt',
      submit: 'Verfügbare anzeigen',
      trustInclusive: 'Alles inklusive',
      trustResponse: 'Antwort < 24 h',
      trustContract: 'Schweizer Mietvertrag',
      miniAvailableNow: 'Ab sofort frei',
      miniAvailableFrom: 'Frei ab {date}',
      imageAlt: 'Möbliertes WG-Zimmer in Zürich Seefeld — Bett, Schreibtisch und grosses Fenster',
    },

    // Startseite v2 — „Aktuell frei in Zürich"
    homeAvailable: {
      title: 'Aktuell frei in Zürich',
      viewAll: 'Alle WG-Zimmer ansehen',
      emptyHint: 'Gerade ist hier kein Zimmer gelistet — alle aktuellen WG-Zimmer in Zürich findest du auf der Übersichtsseite.',
      emptyCta: 'WG-Zimmer in Zürich ansehen',
    },

    // Startseite v2 — „So funktioniert's" (Wording: Inhaber-Entscheidung 3)
    homeSteps: {
      title: "So funktioniert's",
      step1Title: 'Besichtigen',
      step1Desc: 'Termin in 30 Sekunden anfragen — vor Ort oder per Video.',
      step2Title: 'Bewerben',
      step2Desc: 'Digital in wenigen Minuten.',
      step3Title: 'Einziehen',
      step3Desc: 'Schlüssel übernehmen — WLAN läuft, Bett steht, fertig.',
    },

    // Startseite v2 — Städte + B2B-Strip
    homeCities: {
      title: 'Unsere Städte',
      availableOne: '1 Zimmer verfügbar',
      availableMany: '{n} Zimmer verfügbar',
      waitlist: 'Warteliste',
      b2bText: 'Wohnlösungen für Ihr Team? Möblierte Apartments für Unternehmen.',
      b2bCta: 'Für Firmen',
    },

    // ListingCard v2 (Startseite, Listing, „Ähnliche Zimmer")
    listingCard: {
      availableNow: 'Ab sofort',
      availableFrom: 'Frei ab {date}',
      perMonth: '/ Mt.',
      details: 'Details',
    },

    // Detailseite v2 (R4.3) — Kopf, Galerie, Sidebar, ähnliche Zimmer
    detailPage: {
      aboutRoom: 'Über dieses Zimmer',
      aboutApartment: 'Über diese Wohnung',
      amenities: 'Ausstattung',
      flatmatesTitle: 'Das Haus & deine Mitbewohner',
      location: 'Lage',
      exactLocation: 'Standort:',
      approximateLocation: 'Ungefährer Standort in',
      allPhotos: 'Alle {n} Fotos',
      perMonth: '/ Monat',
      allInLine: 'Alles inklusive — Nebenkosten, WLAN, Strom',
      factSize: 'Grösse',
      factBedrooms: 'Schlafzimmer',
      factBathrooms: 'Badezimmer',
      factAvailable: 'Verfügbar',
      factMinStay: 'Mindestmiete',
      factMinStayValue: '3 Monate',
      similarRooms: 'Ähnliche Zimmer',
      similarApartments: 'Ähnliche Wohnungen',
    },

    // Inserat teilen (Detailseite) — natives Share-Sheet bzw. Link kopieren
    share: {
      label: 'Teilen',
      ariaLabel: 'Inserat teilen',
      copied: 'Link kopiert',
      copiedToast: 'Link wurde kopiert.',
      copyError: 'Link konnte nicht kopiert werden.',
      textRoom: 'Schau dir dieses WG-Zimmer bei FeelAtHomeNow an:',
      textApartment: 'Schau dir diese Wohnung bei FeelAtHomeNow an:',
    },

    // Verfügbarkeits-Alert (H11) — Block + Dialog
    alertBlock: {
      titleRoom: 'Kein passendes Zimmer frei?',
      titleApartment: 'Keine passende Wohnung frei?',
      textRoom: 'Trag dich ein — wir melden uns zuerst bei dir, sobald in {city} ein Zimmer frei wird.',
      textApartment: 'Trag dich ein — wir melden uns zuerst bei dir, sobald in {city} eine Wohnung frei wird.',
      cta: 'Benachrichtigen',
      dialogTitle: 'Verfügbarkeits-Alert einrichten',
      dialogText: 'E-Mail eintragen — wir melden uns, sobald in deiner Stadt etwas frei wird.',
      cityLabel: 'Stadt',
      emailLabel: 'E-Mail',
      submit: 'Benachrichtigen',
      submitting: 'Wird gesendet…',
      successToast: 'Eingetragen — wir melden uns, sobald etwas frei wird.',
      errorEmail: 'Bitte gib eine gültige E-Mail-Adresse ein.',
      errorGeneric: 'Fehler beim Senden. Bitte versuche es später erneut.',
    },

    // B2B-Anfrageformular (R4.4) — Für Unternehmen / Für Immobilienverwalter
    b2bForm: {
      title: 'Anfrage senden',
      text: 'Erzählen Sie uns kurz von Ihrem Bedarf — wir melden uns innert 24 h.',
      nameLabel: 'Name',
      emailLabel: 'E-Mail',
      phoneLabel: 'Telefon (optional)',
      companyLabel: 'Firma',
      headcountLabel: 'Mitarbeiterzahl / Bedarf (optional)',
      headcountPlaceholder: 'z. B. 3 Mitarbeitende, 6 Monate',
      inquiryLabel: 'Wie können wir Ihnen helfen?',
      inquiryPlaceholder: 'Bitte auswählen',
      messageLabel: 'Nachricht',
      submit: 'Anfrage senden',
      submitting: 'Wird gesendet…',
      successToast: 'Anfrage gesendet — wir melden uns innert 24 h.',
      errorName: 'Bitte geben Sie Ihren Namen ein.',
      errorEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
      errorCompany: 'Bitte geben Sie Ihre Firma an.',
      errorInquiry: 'Bitte wählen Sie eine Option.',
      errorMessage: 'Ihre Nachricht muss mindestens 10 Zeichen lang sein.',
      errorGeneric: 'Fehler beim Senden. Bitte versuchen Sie es später erneut.',
    },

    
    // Contact Section
    contact: {
      title: "Kontaktieren Sie uns",
      subtitle: "Wir helfen Ihnen gerne bei der Suche nach Ihrer perfekten Unterkunft",
      namePlaceholder: "Name",
      emailPlaceholder: "E-Mail",
      phonePlaceholder: "Telefon",
      companyPlaceholder: "Unternehmen (optional)",
      messagePlaceholder: "Ihre Nachricht",
      submit: "Jetzt bewerben",
      successMessage: "Vielen Dank! Wir melden uns in Kürze bei Ihnen.",
    },

    // WhatsApp entry points (header, chat widget, contact page)
    whatsapp: {
      chatOption: "Direkt per WhatsApp schreiben",
      funnelOption: "Passendes WG-Zimmer finden",
      contactCardTitle: "Lieber direkt schreiben?",
      contactCardHint: "Antwort meist innert Stunden (Mo–Fr)",
      contactCardCta: "WhatsApp öffnen",
      ariaChat: "WhatsApp Chat öffnen",
    },

    // Chat widget shell
    chatWidget: {
      openChat: "Chat öffnen",
      closeChat: "Chat schliessen",
    },

    // Sticky mobile conversion bar (detail page, <lg)
    stickyBar: {
      allIn: "all-in",
      apply: "Jetzt bewerben",
      whatsappAria: "Per WhatsApp schreiben",
    },

    // Viewing request (detail CTA stack + modal)
    viewing: {
      ctaViewing: "Besichtigung anfragen",
      ctaWhatsApp: "WhatsApp schreiben",
      ctaApply: "Jetzt bewerben",
      ctaCallPrefix: "oder anrufen:",
      trustLine: "Schweizer Mietvertrag · FeelAtHomeNow GmbH",
      modalTitle: "Besichtigung anfragen",
      modalSubtitle: "Kurz eintragen — wir melden uns innert 24 h mit Terminvorschlägen.",
      nameLabel: "Name",
      phoneLabel: "Telefon",
      emailLabel: "E-Mail",
      timeWindowLabel: "Zeitfenster",
      timeThisWeek: "Diese Woche",
      timeNextWeek: "Nächste Woche",
      timeFlexible: "Flexibel",
      messageLabel: "Nachricht (optional)",
      submit: "Anfrage senden",
      submitting: "Wird gesendet…",
      successToast: "Anfrage gesendet — wir melden uns innert 24 h",
      errorName: "Bitte geben Sie Ihren Namen ein.",
      errorPhone: "Bitte geben Sie eine gültige Telefonnummer ein.",
      errorEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
      errorTimeWindow: "Bitte wählen Sie ein Zeitfenster.",
      errorGeneric: "Fehler beim Senden. Bitte versuchen Sie es später erneut.",
    },

    // Footer
    footer: {
      tagline: "Ihr Zuhause in der Schweiz",
      quickLinks: "Schnelllinks",
      services: "Dienstleistungen",
      locations: "Standorte",
      zurich: "Zürich",
      geneva: "Genf",
      basel: "Basel",
      zug: "Zug",
      rights: "Alle Rechte vorbehalten.",
      // NavyFooter v2 (R3.6): integrierter Schluss-CTA
      ctaTitle: "Bereit für dein neues Zuhause in Zürich?",
      ctaText: "Besichtigung anfragen oder direkt schreiben — Antwort meist innert Stunden.",
      ctaButton: "Zimmer ansehen",
      ctaWhatsApp: "WhatsApp",
      activeIn: "Tätig in",
      headquarters: "Hauptsitz: Gerlafingen (SO), Schweiz",
    },
    
    // Apartments Page
    apartmentsPage: {
      // H1 + Intro pro Typ und Stadt (R2.2/H3) — {city} wird interpoliert
      headingRoomsCity: "Möblierte WG-Zimmer in {city}",
      headingRoomsCountry: "Möblierte WG-Zimmer in der Schweiz",
      headingAptsCity: "Möblierte Wohnungen in {city}",
      headingAptsCountry: "Möblierte Wohnungen in der Schweiz",
      headingLegacy: "Möblierte Zimmer & Wohnungen in der Schweiz",
      introRooms: "Einzelzimmer in geteilten Wohnungen — alles inklusive, flexibel ab 3 Monaten, sofort beziehbar. Shared Living für Expats, Studierende und Professionals.",
      introApts: "Komplett eingerichtete Wohnungen — alles inklusive, flexibel mietbar, sofort bezugsbereit. Für Expats, Professionals und Unternehmen.",
      introLegacy: "Möblierte WG-Zimmer und komplette Wohnungen — alles inklusive, flexibel mietbar, sofort bezugsbereit.",
      emptyRoomsTitle: "Momentan keine WG-Zimmer verfügbar",
      emptyAptsTitle: "Momentan keine Wohnungen verfügbar",
      emptyMixedTitle: "Momentan keine WG-Zimmer und Wohnungen verfügbar",
      emptyRoomsBody: "Wir erhalten laufend neue möblierte WG-Zimmer. Senden Sie uns eine Anfrage und wir informieren Sie sofort.",
      emptyAptsBody: "Wir erhalten laufend neue möblierte Wohnungen. Senden Sie uns eine Anfrage und wir informieren Sie sofort.",
      crumbMixed: "Wohnungen & Zimmer",
      filterAll: "Alle",
      filterZurich: "Zürich",
      filterGeneva: "Genf",
      filterBasel: "Basel",
      filterZug: "Zug",
      // Listing v2 (R4.2): Count-Zeile + Filterleiste
      countRoomOne: "1 Zimmer",
      countRoomMany: "{n} Zimmer",
      countAptOne: "1 Wohnung",
      countAptMany: "{n} Wohnungen",
      countMixedOne: "1 Angebot",
      countMixedMany: "{n} Angebote",
      countAvailableNow: "{n} ab sofort frei",
      filterAvailableNow: "Ab sofort",
      sortAria: "Sortierung",
      sortDefault: "Sortieren",
      sortPriceAsc: "Preis aufsteigend",
      sortPriceDesc: "Preis absteigend",
    },
    
    // For Companies Page
    companiesPage: {
      title: "Wohnlösungen für Unternehmen",
      subtitle: "Professionelle Unterkünfte für Ihre umziehenden Mitarbeiter",
      heroText: "Wir bieten massgeschneiderte Wohnlösungen für Unternehmen, die Mitarbeiter in der Schweiz umziehen. Von kurzen Geschäftsreisen bis zu langfristigen Projekten.",
      ctaButton: "Jetzt anfragen",
      trust1: "Schnell & zuverlässig",
      trust2: "Persönliche Beratung",
      trust3: "Massgeschneiderte Lösungen",
      whyTitle: "Warum FeelAtHomeNow?",
      feature1Title: "Zentrale Standorte",
      feature1Desc: "Apartments in der Nähe von Geschäftszentren und öffentlichen Verkehrsmitteln.",
      feature2Title: "Flexible Laufzeiten",
      feature2Desc: "Von wenigen Wochen bis zu mehreren Jahren – wir passen uns Ihren Bedürfnissen an.",
      feature3Title: "Komplettservice",
      feature3Desc: "Möblierung, Einrichtung, Internet und alle Nebenkosten inklusive.",
      comfortTitle1: "Zuhause auf Zeit.",
      comfortTitle2: "Damit sich Ihre Mitarbeiter vom ersten Tag an wohlfühlen.",
      comfortText: "Wir kümmern uns um alles, damit sich Ihre Mitarbeiter von Anfang an wie zu Hause fühlen können.",
      comfortCta: "Mehr erfahren",
      formTitle: "Anfrage senden",
      formText: "Erzählen Sie uns kurz von Ihrem Bedarf – wir melden uns innerhalb von 24 Stunden.",
      bottomTrust1: "Sichere Buchung",
      bottomTrust2: "DSGVO-konform",
      bottomTrust3: "Persönlicher Support",
      bottomTrust4: "Bewährter Service",
      imageAltHero: "Modernes Glas-Bürogebäude in der Abendsonne",
      imageAltLiving: "Helles Wohnzimmer mit Seeblick",
    },

    // Wohnungen-Landing (R5.4) — Marketing-Seite mit echten API-Listings
    wohnungenPage: {
      heroSubtitle: "Komplett eingerichtete Wohnungen – alles inklusive, flexibel mietbar und sofort bezugsbereit. Für Expats, Professionals und Unternehmen.",
      heroTrust1: "Alles inklusive",
      heroTrust2: "Anreise ab 2h",
      heroTrust3: "Schweizweit",
      infoCardTitle: "Komfortabel wohnen",
      infoCardText: "Möbliert, zentral und sofort bezugsbereit.",
      usp1Title: "Voll möbliert",
      usp1Desc: "Einziehen und wohlfühlen.",
      usp2Title: "Internet inklusive",
      usp2Desc: "WLAN in jeder Wohnung.",
      usp3Title: "Anmeldung möglich",
      usp3Desc: "Wir unterstützen Sie bei der Anmeldung.",
      usp4Title: "Flexible Mietdauer",
      usp4Desc: "Monatlich kündbar oder langfristig.",
      usp5Title: "Persönlicher Service",
      usp5Desc: "Wir sind für Sie da – schnell und unkompliziert.",
      usp6Title: "Für Unternehmen",
      usp6Desc: "Wohnlösungen für Mitarbeitende und Teams.",
      listingsTitle: "Verfügbare Wohnungen",
      emptyTitle: "Aktuell keine Wohnungen verfügbar",
      emptyText: "Unsere Wohnungen sind oft schnell vermietet. Lassen Sie sich benachrichtigen, sobald eine passende Wohnung frei wird.",
      emptyHint: "Kein Spam. Jederzeit abmeldbar.",
      altTitle: "Beliebte Alternativen",
      altText: "Vielleicht ist aktuell ein WG-Zimmer die passende Lösung für Sie.",
      altCta: "Zu den WG-Zimmern",
      stepsTitle: "So funktioniert's",
      step1Title: "Besichtigen",
      step1Desc: "Termin in 30 Sekunden anfragen – vor Ort oder per Video.",
      step2Title: "Bewerben",
      step2Desc: "Digital in wenigen Minuten.",
      step3Title: "Einziehen",
      step3Desc: "Schlüssel übernehmen – WLAN läuft, Bett steht, fertig.",
      trustBar1Title: "Sichere Buchung",
      trustBar1Desc: "Verifizierte Wohnungen",
      trustBar2Title: "Keine versteckten Kosten",
      trustBar2Desc: "Alles klar und transparent",
      trustBar3Title: "Persönlich für Sie da",
      trustBar3Desc: "Service, der weiterhilft",
      trustBar4Title: "Verifizierte Inserate",
      trustBar4Desc: "Echte, geprüfte Angebote",
      imageAltHero: "Helles Wohnzimmer mit Seeblick",
      imageAltSessel: "Gemütlicher Sessel mit Stehlampe",
    },

    // WG-Zimmer-Landing (R5.5) — gestaltete Seite mit echten API-Listings
    zimmerPage: {
      heroTitlePre: "Finde dein ",
      heroTitleAccent: "Zuhause",
      heroTitlePost: " in Zürich",
      heroSubtitle: "Möblierte Zimmer ab 3 Monaten – inklusive Internet, Anmeldung und internationaler Community.",
      heroTrust1: "Voll möbliert",
      heroTrust2: "Anmeldung möglich",
      heroTrust3: "Flexible Mietdauer",
      heroTrust4: "Video-Besichtigung",
      filterAria: "Zimmer filtern",
      filterCity: "Stadt",
      filterPrice: "Preis",
      filterAvailable: "Verfügbar ab",
      filterSize: "Zimmergrösse",
      filterReset: "Filter zurücksetzen",
      cityAll: "Alle Städte",
      priceAny: "Beliebig",
      priceAsc: "Günstigste zuerst",
      priceDesc: "Teuerste zuerst",
      availAny: "Beliebig",
      availNow: "Sofort verfügbar",
      sizeAll: "Alle",
      sizeUnder15: "bis 15 m²",
      size15to20: "15–20 m²",
      sizeOver20: "über 20 m²",
      highlightBadge: "Verfügbar",
      highlightCta: "Jetzt ansehen",
      gridLoadMore: "Weitere Zimmer laden",
      whyTitle: "Warum FeelAtHomeNow?",
      why1Title: "Top-Lagen in Zürich",
      why1Desc: "Zentrale Wohnlagen mit bester Anbindung.",
      why2Title: "Anmeldung möglich",
      why2Desc: "Wir unterstützen dich bei der Anmeldung in Zürich.",
      why3Title: "Voll möbliert",
      why3Desc: "Einziehen, wohlfühlen, ankommen.",
      why4Title: "Internationale Community",
      why4Desc: "Werde Teil einer offenen und hilfsbereiten Community.",
      why5Title: "Flexible Mietdauer",
      why5Desc: "Ab 3 Monaten – verlängern jederzeit möglich.",
      why6Title: "Persönliche Betreuung",
      why6Desc: "Unser Team ist für dich da – vor und nach dem Einzug.",
      bannerTitle: "Noch kein passendes Zimmer gefunden?",
      bannerText: "Wir informieren dich sofort, wenn ein neues Zimmer in Zürich frei wird.",
      bannerHint: "Unverbindlich & jederzeit abbestellbar.",
      trustBar1: "Sichere Buchung",
      trustBar2: "DSGVO-konform",
      trustBar3: "Persönlicher Support",
      trustBar4: "Bewährter Service",
      imageAltHero: "Helles Wohnzimmer mit Seeblick",
    },

    // Startseite-Rebuild (R5.6) — neue Strings; Listings/Counts aus echter API
    homePage: {
      heroSubtitle: "Komplett eingerichtete Wohnungen – alles inklusive, flexibel mietbar und sofort bezugsbereit. Für Expats, Professionals und Unternehmen.",
      infoCardTitle: "Komfortabel wohnen",
      infoCardText: "Möbliert, zentral und sofort bezugsbereit.",
      heroTrust1: "Alles inklusive",
      heroTrust2: "Anreise ab 2h",
      heroTrust3: "Schweizweit",
      heroTrust4: "Sicher & geprüft",
      usp1Title: "Voll möbliert",
      usp1Desc: "Einziehen und wohlfühlen.",
      usp2Title: "Internet inklusive",
      usp2Desc: "WLAN in jeder Wohnung.",
      usp3Title: "Anmeldung möglich",
      usp3Desc: "Wir unterstützen Sie bei der Anmeldung.",
      usp4Title: "Flexible Mietdauer",
      usp4Desc: "Monatlich kündbar oder langfristig.",
      usp5Title: "Persönlicher Service",
      usp5Desc: "Wir sind für Sie da – schnell und unkompliziert.",
      usp6Title: "Für Unternehmen",
      usp6Desc: "Wohnlösungen für Mitarbeitende und Teams.",
      citiesTitle: "Beliebte Städte",
      citiesViewAll: "Alle Städte anzeigen",
      citySoon: "Bald verfügbar",
      availableViewAll: "Alle Wohnungen in Zürich",
      step1Title: "Suchen",
      step1Desc: "Finden Sie Ihre passende Wohnung – schnell und einfach.",
      step2Title: "Anfragen",
      step2Desc: "Senden Sie eine Anfrage in wenigen Minuten.",
      step3Title: "Einziehen",
      step3Desc: "Schlüssel übernehmen und sich wie zuhause fühlen.",
      trustBar1Title: "Sichere Buchung",
      trustBar1Desc: "Verifizierte Wohnungen",
      trustBar2Title: "Transparente Preise",
      trustBar2Desc: "Keine versteckten Kosten",
      trustBar3Title: "Persönlicher Service",
      trustBar3Desc: "Wir sind für Sie da",
      trustBar4Title: "Verifizierte Wohnungen",
      trustBar4Desc: "Echte, geprüfte Inserate",
      imageAltHero: "Helles Wohnzimmer mit Seeblick",
    },
    
    // For Property Managers Page
    propertyManagersPage: {
      title: 'Für Immobilienverwalter',
      eyebrow: 'Für Immobilienverwalter',
      heroLine1: 'Weniger Leerstand.',
      heroLine2: 'Weniger Aufwand.',
      heroLine3: 'Zuverlässige Mieter.',
      heroSubtitle:
        'Wir übernehmen Vermarktung, Besichtigungen, Mieterprüfung und Betreuung – damit Ihre Wohnungen dauerhaft ausgelastet bleiben.',
      ctaPrimary: 'Partner werden',
      ctaSecondary: 'Kostenloses Gespräch vereinbaren',
      benefitsTitle: 'Ihre Vorteile auf einen Blick',
      benefit1Title: 'Vermietung aus einer Hand',
      benefit1Desc:
        'Wir übernehmen Inserate, Besichtigungen und die komplette Kommunikation – effizient und professionell.',
      benefit2Title: 'Geprüfte Mieter',
      benefit2Desc:
        'Internationale Fachkräfte, Expats und Berufstätige mit stabilem Einkommen und sauberem Hintergrund.',
      benefit3Title: 'Spezialisiert auf befristete Mietverträge',
      benefit3Desc:
        'Unsere Kernkompetenz: befristete Mietverträge von 1 bis 24 Monaten – flexibel, rechtssicher und planbar.',
      benefit4Title: 'Weniger Leerstand',
      benefit4Desc:
        'Schnelle Nachvermietung und kontinuierliche Auslastung sorgen für planbare Einnahmen.',
      partnerEyebrow: 'Ihr Partner in Zürich',
      partnerTitle: 'Ihr Vermietungspartner mit Mehrwert',
      partnerText:
        'Wir unterstützen Eigentümer und Verwaltungen dabei, den Wert ihrer Immobilien zu steigern – mit einem professionellen und persönlichen Service.',
      partnerCheck1: 'Professionelle Vermarktung auf allen relevanten Kanälen',
      partnerCheck2: 'Sorgfältige Mieterselektion und Bonitätsprüfung',
      partnerCheck3: 'Durchführung von Besichtigungen (vor Ort oder digital)',
      partnerCheck4: 'Vertragsabwicklung und Anmeldeprozess',
      partnerCheck5: 'Betreuung während der gesamten Mietdauer',
      partnerCheck6: 'Regelmässige Reports und transparente Kommunikation',
      partnerCta: 'Partnerschaft anfragen',
      whyTitle: 'Warum Verwaltungen mit FeelAtHomeNow arbeiten',
      why1Title: 'Fokus auf langfristige Mietverhältnisse',
      why1Desc: 'Zufriedene Mieter, weniger Wechsel, mehr Stabilität.',
      why2Title: 'Internationale Fachkräfte und Expats',
      why2Desc: 'Zielgruppe mit hoher Zuverlässigkeit und Wertschätzung.',
      why3Title: 'Spezialisiert auf den Standort Zürich',
      why3Desc: 'Lokale Expertise und starkes Netzwerk.',
      why4Title: 'Persönlicher Ansprechpartner',
      why4Desc: 'Direkte Kommunikation und schnelle Entscheidungen.',
      why5Title: 'Schnelle und effiziente Prozesse',
      why5Desc: 'Von der Anfrage bis zum Einzug – ohne Umwege.',
      formTitle: 'Lassen Sie uns über Ihre Immobilie sprechen',
      formText:
        'Ob einzelne Wohnungen oder ganze Liegenschaften – wir prüfen gerne eine mögliche Zusammenarbeit und erstellen Ihnen ein unverbindliches Konzept.',
      formInquirySingle: 'Einzelne Wohnung vermieten',
      formInquiryMultiple: 'Mehrere Wohnungen / Liegenschaft',
      formInquiryGeneral: 'Allgemeine Anfrage',
      imageAltHero: 'Moderne Wohnsiedlung in Zürich in der Abendsonne',
      imageAltBuilding: 'Mehrfamilienhaus an einer Strasse in Zürich',
    },
    
    // About Page v2 (R4.4) — Story ohne unbelegte Zahlenclaims (Regel 14)
    aboutPage: {
      title: "Über FeelAtHomeNow",
      subtitle: "Wir schaffen ein Zuhause für internationale Professionals in der Schweiz",
      storyEyebrow: "Unsere Geschichte",
      storyTitle: "Zuhause in Zürich – für Internationale wie für uns.",
      story1: "FeelAtHomeNow entstand aus der Idee, internationalen Professionals, Expats und Studierenden den Start in der Schweiz einfacher zu machen. Gerade in Zürich ist es schwierig, kurzfristig passende Wohnungen zu finden – genau hier setzen wir an.",
      story2: "Jedes Zimmer richten wir so ein, dass nur noch der Koffer fehlt: Möbel, WLAN, Nebenkosten und Anmeldung – alles inklusive. Besichtigt wird vor Ort oder per Video – auch aus dem Ausland. Die Verträge sind flexibel ab 3 Monaten Mindestmietdauer.",
      story3: "Hinter FeelAtHomeNow steht langjährige Verwaltungserfahrung und der Anspruch, nicht nur Unterkünfte anzubieten, sondern ein echtes Zuhause auf Zeit – mit persönlichem Service und einer internationalen Community, in der Deutsch und Englisch zum Alltag gehören.",
      uspEyebrow: "Wohnen bei FeelAtHomeNow",
      uspTitle: "Mehr als ein Zimmer – ein echtes Zuhause.",
      uspText: "Sorgfältig für dich ausgewählt – vom voll möblierten Zimmer bis zur internationalen Community:",
      uspItem1: "Voll möbliert",
      uspItem2: "Anmeldung möglich",
      uspItem3: "Internationale Community",
      uspItem4: "Video-Besichtigung",
      uspCta: "Verfügbare WG-Zimmer ansehen",
      valuesEyebrow: "Unsere Werte",
      valuesTitle: "Dafür stehen wir",
      value1Title: "Zuhause auf Zeit",
      value1Desc: "Voll möblierte Zimmer mit allem, was du zum Ankommen brauchst.",
      value2Title: "Internationale Community",
      value2Desc: "Werde Teil einer offenen Community und knüpfe weltweit Kontakte.",
      value3Title: "Top-Lagen in Zürich",
      value3Desc: "Zentrale Standorte mit bester Anbindung an Stadt, Uni und Arbeit.",
      value4Title: "Anmeldung möglich",
      value4Desc: "Wir ermöglichen die amtliche Anmeldung – unkompliziert und rechtssicher.",
      value5Title: "Flexibel & digital",
      value5Desc: "Besichtigung vor Ort oder per Video – auch aus dem Ausland.",
      imageAltHero: "Helle Fensterbank mit Pflanze, Büchern und Kaffeetasse",
      imageAltZimmer: "Möbliertes Zimmer mit orangefarbenem Bett",
      imageAltTerrasse: "Dachterrasse mit Lounge bei Sonnenuntergang",
    },

    // Application Modal — full 5-step wizard
    application: {
      modal: {
        title: 'Bewerbung für WG-Zimmer',
      },
      common: {
        back: 'Zurück',
        next: 'Weiter',
        submit: 'Bewerbung absenden',
        submitting: 'Wird gesendet…',
        stepOf: 'Schritt {n} von 5',
        stepAriaLabel: 'Schritt {n}: {label}',
        edit: 'Bearbeiten',
        editHint: 'Zurück über die Schritte oben ändern',
        selectPlaceholder: 'Bitte wählen…',
        yes: 'Ja',
        no: 'Nein',
        dash: '—',
      },
      steps: {
        personal: 'Persönlich',
        profession: 'Beruf',
        finance: 'Finanzen',
        shared: 'WG',
        documents: 'Dokumente',
      },
      errors: {
        required: 'Pflichtfeld',
        invalidValue: 'Ungültiger Wert',
        emailInvalid: 'Ungültige E-Mail-Adresse',
        phoneInvalid: 'Ungültige Telefonnummer',
        selectFromList: 'Bitte aus der Liste auswählen',
        firstAndLastName: 'Bitte Vor- und Nachname eingeben',
        atLeastOneLanguage: 'Bitte mindestens eine Sprache auswählen',
        pleaseExplain: 'Bitte kurz erläutern',
        maxChars: 'Max. {n} Zeichen',
        pleaseProvideDuration: 'Bitte Dauer angeben',
        pleaseProvide: 'Bitte angeben',
        pleaseConfirm: 'Bitte bestätigen',
        pleaseAccept: 'Bitte akzeptieren',
        idRequired: 'ID/Pass ist Pflicht',
        fileType: 'Nur PDF, JPG oder PNG erlaubt',
        fileSize: 'Datei zu gross (max. 10 MB)',
        sendStatus: 'Fehler beim Senden ({status})',
        sendGeneric: 'Bewerbung konnte nicht gesendet werden. Bitte später erneut versuchen.',
      },
      toast: {
        sent: 'Bewerbung gesendet',
      },
      files: {
        hint: 'PDF, JPG, PNG · max. 10 MB',
        select: 'Datei auswählen',
        addReference: 'Referenz hinzufügen',
        remove: 'Entfernen',
      },
      langPicker: {
        add: 'Sprachen hinzufügen...',
        search: 'Sprache suchen...',
        empty: 'Keine Sprache gefunden',
        removeAria: '{lang} entfernen',
      },
      step1: {
        applicantType: 'Bewerbertyp',
        applicantIndividual: 'Privatperson',
        applicantCompany: 'Firma',
        companyName: 'Firmenname',
        companyRegistrationNo: 'Handelsregisternummer / UID',
        companyRegistrationPlaceholder: 'z.B. CHE-123.456.789',
        companyPosition: 'Position / Funktion',
        companyPositionPlaceholder: 'z.B. Geschäftsführer',
        contactPerson: 'Name Kontaktperson',
        contactPersonPlaceholder: 'Vollständiger Name',
        contactPersonHint: 'Vor- und Nachname der Kontaktperson',
        salutation: 'Anrede',
        salutationMr: 'Herr',
        salutationMs: 'Frau',
        salutationDiverse: 'Divers',
        salutationNone: 'Keine Angabe',
        firstName: 'Vorname',
        lastName: 'Nachname',
        email: 'E-Mail',
        phone: 'Telefon',
        birthDate: 'Geburtsdatum',
        nationality: 'Nationalität',
        nationalityPlaceholder: 'Land eingeben oder auswählen',
        residencePermit: 'Aufenthaltsbewilligung',
        languages: 'Welche Sprachen sprichst du?',
        addressStreet: 'Strasse und Nummer',
        addressZip: 'PLZ',
        addressCity: 'Ort',
        source: 'Wie haben Sie uns gefunden?',
        sourceGoogle: 'Google / Suchmaschine',
        sourceFacebookInstagram: 'Facebook / Instagram',
        sourceDirectWebsite: 'Direkt über die Website',
        sourceReferral: 'Empfehlung',
        sourceSonstiges: 'Sonstiges',
        sourceReferralLabel: 'Wer hat Sie empfohlen?',
        sourceReferralPlaceholder: 'Name der empfehlenden Person (optional)',
        sourceSonstigesLabel: 'Wo genau?',
        sourceSonstigesPlaceholder: 'Bitte kurz beschreiben',
      },
      step2: {
        occupation: 'Beruf / Tätigkeit',
        occupationEmployed: 'Angestellt',
        occupationSelfEmployed: 'Selbständig',
        occupationStudent: 'Student',
        occupationApprentice: 'Auszubildend',
        occupationJobSeeker: 'Arbeitssuchend',
        occupationRetiree: 'Rentner',
        occupationOther: 'Sonstiges',
        occupationOtherSpecify: 'Bitte angeben',
        employer: 'Arbeitgeber / Firma',
        grossIncome: 'Monatliches Bruttoeinkommen',
        workStyle: 'Arbeitsform',
        workStyleOffice: 'Büro',
        workStyleHome: 'Homeoffice',
        workStyleHybrid: 'Hybrid',
        workStyleStudent: 'Student',
        moveInDate: 'Gewünschtes Einzugsdatum',
        rentDuration: 'Gewünschte Mietdauer',
        rentDuration3m: '3 Monate',
        rentDuration6m: '6 Monate',
        rentDuration9m: '9 Monate',
        rentDuration12m: '12 Monate',
        rentDurationIndefinite: 'Unbefristet',
        whoMovesIn: 'Wer zieht ein?',
        occupantName: 'Name der einziehenden Person',
        occupantNamePlaceholder: 'Vor- und Nachname',
        occupantCount: 'Anzahl Personen',
        bookingFor: 'Gebucht für',
        bookingEmployee: 'Mitarbeiter',
        bookingExpat: 'Expat',
        bookingConsultant: 'Consultant / Freelancer',
        bookingGuest: 'Gast / temporärer Mitarbeiter',
        bookingOther: 'Andere',
      },
      step3: {
        info: 'Ihre Angaben werden vertraulich behandelt und dienen der Bonitätsprüfung.',
        debtCollections: 'Betreibungen in den letzten 24 Monaten?',
        openCollections: 'Offene Inkasso-Verfahren?',
        lossCertificates: 'Verlustscheine vorhanden?',
        financialNotes: 'Kurze Erläuterung',
      },
      step4: {
        wgExperience: 'WG-Erfahrung?',
        wgExperienceDuration: 'Wie lange?',
        wgExperienceDurationPlaceholder: 'z.B. 2 Jahre',
        dayRhythm: 'Tagesrhythmus',
        dayRhythmEarlyBird: 'Frühaufsteher',
        dayRhythmNightOwl: 'Nachteule',
        dayRhythmNormal: 'Normal',
        socialStyle: 'Sozialverhalten',
        socialStyleQuiet: 'Eher ruhig',
        socialStyleSocial: 'Eher gesellig',
        socialStyleBalanced: 'Ausgewogen',
        smoker: 'Raucher?',
        cleanliness: 'Sauberkeit & Ordnung',
        cleanlinessVeryImportant: 'Sehr wichtig',
        cleanlinessImportant: 'Wichtig',
        cleanlinessNormal: 'Normal',
        cleanlinessRelaxed: 'Eher locker',
        pets: 'Haustiere?',
        petsDetails: 'Welche?',
        petsDetailsPlaceholder: 'z.B. 1 Katze',
        visitors: 'Besucher / Party',
        visitorsRare: 'Selten',
        visitorsOccasional: 'Gelegentlich',
        visitorsOften: 'Oft',
        wgRules: 'Ich bin bereit, die WG-Regeln einzuhalten',
        selfDescription: 'Kurze Selbstbeschreibung als Mitbewohner',
        motivationRoom: 'Warum dieses Zimmer?',
        motivationWg: 'Warum WG?',
      },
      step5: {
        documentsHeading: 'Dokumente',
        documentId: 'ID-Kopie / Pass',
        documentWorkContract: 'Arbeitsvertrag oder Immatrikulationsbescheinigung',
        documentDebtExtract: 'Betreibungsauszug',
        documentReferences: 'Referenzschreiben (mehrere möglich)',
        reviewHeading: 'Überblick',
        reviewAddress: 'Adresse',
        reviewName: 'Name',
        reviewNationalityWithPermit: '{nationality} (Bewilligung {permit})',
        reviewOccupantName: 'Einziehende Person',
        reviewOccupationOther: 'Sonstiges – {value}',
        reviewIncome: 'Einkommen',
        reviewMoveIn: 'Einzug',
        reviewMietdauer: 'Mietdauer',
        reviewCompanyRegistration: 'Handelsregister / UID',
        reviewPosition: 'Position',
        reviewContactPerson: 'Kontaktperson',
        reviewSauberkeit: 'Sauberkeit',
        consentsHeading: 'Optionale Einwilligungen',
        consentCreditCheck: 'Ich willige ein, dass FeelAtHomeNow eine Bonitätsprüfung bei einer Schweizer Wirtschaftsauskunftei (z.B. CRIF, Intrum) zur Beurteilung meiner Zahlungsfähigkeit einholen darf.',
        consentReferenceCheck: 'Ich willige ein, dass FeelAtHomeNow bei meinem bisherigen Vermieter und/oder Arbeitgeber Referenzauskünfte einholen darf.',
        consentOptional: '(Optional)',
        consentConfirmCorrect: 'Ich bestätige, dass alle Angaben wahrheitsgemäss sind',
        privacyPrefix: 'Ich habe die ',
        privacyLink: 'Datenschutzbestimmungen',
        privacySuffix: ' gelesen und akzeptiere die Verarbeitung meiner Daten für die Bearbeitung meiner Bewerbung.',
      },
      success: {
        title: 'Vielen Dank! Ihre Bewerbung wurde eingereicht.',
        subtitle: 'Ihre Unterlagen für {title} sind bei uns eingegangen.',
        info24h: 'Wir melden uns innerhalb von 24 h.',
        infoEmail: 'Sie erhalten eine Bestätigung per E-Mail.',
        close: 'Schliessen',
      },
      apply: {
        seoTitle: 'Bewerbung',
        notAvailableTitle: 'Dieses Objekt ist nicht mehr verfügbar',
        notAvailableBody: 'Die von Ihnen aufgerufene Wohnung existiert nicht mehr oder wurde entfernt. Schauen Sie sich unsere aktuellen Angebote an.',
        backToApartments: 'Zurück zu allen Wohnungen',
        reapply: 'Erneut bewerben',
        chooseRoom: 'Wählen Sie Ihr Zimmer',
        perMonth: '/Monat',
      },
    },
  },

  en: {
    // Navigation
    nav: {
      home: "Home",
      apartments: "Apartments",
      rooms: "Rooms",
      blog: "Blog",
      forCompanies: "For Companies",
      forPropertyManagers: "For Property Managers",
      about: "About",
      contact: "Contact",
      ctaRooms: "View rooms",
    },

    // Hero Section — Zurich refocus + all-in promise (R2.4/H3)
    hero: {
      headline: "Furnished Rooms & Apartments in Zurich",
      subheadline: "Move in and arrive — furniture, Wi-Fi and utilities are already included. Flexible contracts from 3 months.",
    },

    // Services Section
    services: {
      title: "Our Housing Solutions",
      subtitle: "Professional and flexible accommodations in Switzerland",
      service1Title: "Entire Apartments",
      service1Desc: "Fully furnished apartments for business travellers and professionals",
      service2Title: "Furnished Rooms",
      service2Desc: "Private room in shared living — perfect for expats and young professionals",
      service3Title: "For Companies",
      service3Desc: "Flexible housing solutions for employees and project teams",
    },

    // Homepage — Living with FeelAtHomeNow (approved USPs only, rule 14).
    // R4F/F6: 'Prime Seefeld location' + 'Rooftop terrace' removed — they
    // don't apply to every property (owner decision).
    homeUsps: {
      label: 'Why FeelAtHomeNow',
      title: 'Living with FeelAtHomeNow',
      intro: 'With years of rental experience, we prepare every room so all you have to do is arrive.',
      usp1Title: 'Fully furnished',
      usp1Desc: 'Bed, wardrobe, desk, kitchen — move in and arrive.',
      usp2Title: 'Registration possible',
      usp2Desc: 'Official registration with the district office is possible at every address.',
      usp3Title: 'International community',
      usp3Desc: 'Housemates from all over the world, German and English in everyday life.',
      usp4Title: 'Video viewings',
      usp4Desc: 'View in person or conveniently by video — even from abroad.',
    },

    // Homepage — FAQ
    homeFaq: {
      label: 'Common Questions',
      title: 'FAQ — Everything About Furnished Housing',
      subtitle: 'Answers to the most important questions about shared rooms, apartments, and co-living in Switzerland',
      q1: 'How does the application for a shared room work?',
      a1: 'Select a shared room in Zurich or another city on our website, fill out the application form, and receive a response within 24 hours. After a brief introductory call, you can move in right away.',
      q2: 'How much does a furnished room in Zurich cost?',
      a2: 'The monthly rent for a furnished room in Zurich ranges from CHF 900 to CHF 2,100 per month depending on location and room size. Utilities, internet, and use of communal areas are included.',
      q3: 'What advantages do business apartments offer companies?',
      a3: 'Business apartments in Zurich and Switzerland offer companies a flexible, immediately available housing solution for relocated employees. Everything is included — from furnishings to internet and utilities. This saves your HR team time and effort.',
      q4: 'In which cities is FeelAtHomeNow available?',
      a4: 'We offer furnished rooms and apartments in Zurich, Basel, Bern, and Geneva as well as other locations across Switzerland. Our portfolio is growing steadily — contact us for current availability.',
      q5: 'How quickly can I move in?',
      a5: 'Thanks to our move-in ready apartments, moving in is often possible within a few days. In urgent cases, we can even organise same-day move-in.',
      q6: 'What is included in the rent?',
      a6: 'The rent includes complete furnishing, utilities, high-speed internet, and a personal contact person. All you need is your suitcase — we take care of the rest.',
      q7: 'What is the notice period?',
      a7: 'The minimum rental period is 3 months. After the minimum period, a notice period of 2 months applies. If you want to stay for just 3 months from the start, you can arrange a fixed-term stay of 3 months.',
    },

    // Homepage v2 — Hero (SearchModule, TrustRow without rating, MiniListingCard)
    homeHero: {
      segmentAria: 'Choose listing type',
      segmentRoom: 'Shared room',
      segmentApartment: 'Apartment',
      cityLabel: 'City',
      submit: 'Show available',
      trustInclusive: 'All-inclusive',
      trustResponse: 'Reply < 24 h',
      trustContract: 'Swiss rental contract',
      miniAvailableNow: 'Available now',
      miniAvailableFrom: 'Free from {date}',
      imageAlt: 'Furnished room in our Zurich Seefeld shared flat — bed, desk and large window',
    },

    // Homepage v2 — "Available now in Zurich"
    homeAvailable: {
      title: 'Available now in Zurich',
      viewAll: 'View all rooms',
      emptyHint: 'No room is listed right here at the moment — find all current rooms in Zurich on the overview page.',
      emptyCta: 'View rooms in Zurich',
    },

    // Homepage v2 — "How it works" (wording: owner decision 3)
    homeSteps: {
      title: 'How it works',
      step1Title: 'View',
      step1Desc: 'Request a slot in 30 seconds — on site or by video.',
      step2Title: 'Apply',
      step2Desc: 'Digitally, in just a few minutes.',
      step3Title: 'Move in',
      step3Desc: 'Pick up the keys — Wi-Fi is running, the bed is ready.',
    },

    // Homepage v2 — cities + B2B strip
    homeCities: {
      title: 'Our Cities',
      availableOne: '1 room available',
      availableMany: '{n} rooms available',
      waitlist: 'Waitlist',
      b2bText: 'Housing for your team? Furnished apartments for companies.',
      b2bCta: 'For companies',
    },

    // ListingCard v2 (homepage, listing, "Similar rooms")
    listingCard: {
      availableNow: 'Available now',
      availableFrom: 'From {date}',
      perMonth: '/ mo.',
      details: 'Details',
    },

    // Detail page v2 (R4.3) — head, gallery, sidebar, similar rooms
    detailPage: {
      aboutRoom: 'About this room',
      aboutApartment: 'About this apartment',
      amenities: 'Amenities',
      flatmatesTitle: 'The house & your flatmates',
      location: 'Location',
      exactLocation: 'Location:',
      approximateLocation: 'Approximate location in',
      allPhotos: 'All {n} photos',
      perMonth: '/ month',
      allInLine: 'All-inclusive — utilities, Wi-Fi, electricity',
      factSize: 'Size',
      factBedrooms: 'Bedrooms',
      factBathrooms: 'Bathrooms',
      factAvailable: 'Available',
      factMinStay: 'Minimum stay',
      factMinStayValue: '3 months',
      similarRooms: 'Similar rooms',
      similarApartments: 'Similar apartments',
    },

    // Share listing (detail page) — native share sheet or copy link
    share: {
      label: 'Share',
      ariaLabel: 'Share listing',
      copied: 'Link copied',
      copiedToast: 'Link copied to clipboard.',
      copyError: 'The link could not be copied.',
      textRoom: 'Check out this room in a shared flat on FeelAtHomeNow:',
      textApartment: 'Check out this apartment on FeelAtHomeNow:',
    },

    // Availability alert (H11) — block + dialog
    alertBlock: {
      titleRoom: 'No suitable room available?',
      titleApartment: 'No suitable apartment available?',
      textRoom: 'Sign up — we will contact you first as soon as a room becomes available in {city}.',
      textApartment: 'Sign up — we will contact you first as soon as an apartment becomes available in {city}.',
      cta: 'Notify me',
      dialogTitle: 'Set up availability alert',
      dialogText: 'Enter your email — we will get in touch as soon as something opens up in your city.',
      cityLabel: 'City',
      emailLabel: 'Email',
      submit: 'Notify me',
      submitting: 'Sending…',
      successToast: 'Signed up — we will contact you as soon as something opens up.',
      errorEmail: 'Please enter a valid email address.',
      errorGeneric: 'Error sending. Please try again later.',
    },

    // B2B inquiry form (R4.4) — For Companies / For Property Managers
    b2bForm: {
      title: 'Send inquiry',
      text: 'Tell us briefly about your needs — we will reply within 24 h.',
      nameLabel: 'Name',
      emailLabel: 'Email',
      phoneLabel: 'Phone (optional)',
      companyLabel: 'Company',
      headcountLabel: 'Headcount / needs (optional)',
      headcountPlaceholder: 'e.g. 3 employees, 6 months',
      inquiryLabel: 'How can we help you?',
      inquiryPlaceholder: 'Please select',
      messageLabel: 'Message',
      submit: 'Send inquiry',
      submitting: 'Sending…',
      successToast: 'Inquiry sent — we will reply within 24 h.',
      errorName: 'Please enter your name.',
      errorEmail: 'Please enter a valid email address.',
      errorCompany: 'Please enter your company.',
      errorInquiry: 'Please select an option.',
      errorMessage: 'Your message must be at least 10 characters long.',
      errorGeneric: 'Error sending. Please try again later.',
    },

    
    // Contact Section
    contact: {
      title: "Contact Us",
      subtitle: "We're happy to help you find your perfect accommodation",
      namePlaceholder: "Name",
      emailPlaceholder: "Email",
      phonePlaceholder: "Phone",
      companyPlaceholder: "Company (optional)",
      messagePlaceholder: "Your message",
      submit: "Apply Now",
      successMessage: "Thank you! We will get back to you shortly.",
    },

    // WhatsApp entry points (header, chat widget, contact page)
    whatsapp: {
      chatOption: "Chat directly on WhatsApp",
      funnelOption: "Find a matching room",
      contactCardTitle: "Prefer to message us directly?",
      contactCardHint: "We usually reply within hours (Mon–Fri)",
      contactCardCta: "Open WhatsApp",
      ariaChat: "Open WhatsApp chat",
    },

    // Chat widget shell
    chatWidget: {
      openChat: "Open chat",
      closeChat: "Close chat",
    },

    // Sticky mobile conversion bar (detail page, <lg)
    stickyBar: {
      allIn: "all-in",
      apply: "Apply now",
      whatsappAria: "Chat on WhatsApp",
    },

    // Viewing request (detail CTA stack + modal)
    viewing: {
      ctaViewing: "Request a viewing",
      ctaWhatsApp: "Chat on WhatsApp",
      ctaApply: "Apply now",
      ctaCallPrefix: "or call:",
      trustLine: "Swiss rental contract · FeelAtHomeNow GmbH",
      modalTitle: "Request a viewing",
      modalSubtitle: "Takes 30 seconds — we get back to you within 24 h with available slots.",
      nameLabel: "Name",
      phoneLabel: "Phone",
      emailLabel: "Email",
      timeWindowLabel: "Time window",
      timeThisWeek: "This week",
      timeNextWeek: "Next week",
      timeFlexible: "Flexible",
      messageLabel: "Message (optional)",
      submit: "Send request",
      submitting: "Sending…",
      successToast: "Request sent — we'll get back to you within 24 h",
      errorName: "Please enter your name.",
      errorPhone: "Please enter a valid phone number.",
      errorEmail: "Please enter a valid email address.",
      errorTimeWindow: "Please choose a time window.",
      errorGeneric: "Error sending. Please try again later.",
    },

    // Footer
    footer: {
      tagline: "Your Home in Switzerland",
      quickLinks: "Quick Links",
      services: "Services",
      locations: "Locations",
      zurich: "Zurich",
      geneva: "Geneva",
      basel: "Basel",
      zug: "Zug",
      rights: "All rights reserved.",
      // NavyFooter v2 (R3.6): integrierter Schluss-CTA
      ctaTitle: "Ready for your new home in Zurich?",
      ctaText: "Request a viewing or message us directly — we usually reply within hours.",
      ctaButton: "View rooms",
      ctaWhatsApp: "WhatsApp",
      activeIn: "Active in",
      headquarters: "Headquarters: Gerlafingen (SO), Switzerland",
    },
    
    // Apartments Page
    apartmentsPage: {
      // H1 + intro per type and city (R2.2/H3) — {city} is interpolated
      headingRoomsCity: "Furnished rooms in shared flats in {city}",
      headingRoomsCountry: "Furnished rooms in shared flats in Switzerland",
      headingAptsCity: "Furnished apartments in {city}",
      headingAptsCountry: "Furnished apartments in Switzerland",
      headingLegacy: "Furnished rooms & apartments in Switzerland",
      introRooms: "Private rooms in shared flats — everything included, flexible from 3 months, ready to move in. Shared living for expats, students, and professionals.",
      introApts: "Fully furnished apartments — everything included, flexible terms, move-in ready. For expats, professionals, and companies.",
      introLegacy: "Furnished rooms in shared flats and entire apartments — everything included, flexible terms, move-in ready.",
      emptyRoomsTitle: "No rooms currently available",
      emptyAptsTitle: "No apartments currently available",
      emptyMixedTitle: "No rooms or apartments currently available",
      emptyRoomsBody: "We continuously receive new furnished rooms. Send us a request and we will inform you immediately.",
      emptyAptsBody: "We continuously receive new furnished apartments. Send us a request and we will inform you immediately.",
      crumbMixed: "Apartments & Rooms",
      filterAll: "All",
      filterZurich: "Zurich",
      filterGeneva: "Geneva",
      filterBasel: "Basel",
      filterZug: "Zug",
      // Listing v2 (R4.2): count line + filter bar
      countRoomOne: "1 room",
      countRoomMany: "{n} rooms",
      countAptOne: "1 apartment",
      countAptMany: "{n} apartments",
      countMixedOne: "1 listing",
      countMixedMany: "{n} listings",
      countAvailableNow: "{n} available now",
      filterAvailableNow: "Available now",
      sortAria: "Sort order",
      sortDefault: "Sort",
      sortPriceAsc: "Price ascending",
      sortPriceDesc: "Price descending",
    },
    
    // For Companies Page
    companiesPage: {
      title: "Housing Solutions for Companies",
      subtitle: "Professional accommodation for your relocating employees",
      heroText: "We provide tailored housing solutions for companies relocating employees to Switzerland. From short business trips to long-term projects.",
      ctaButton: "Request now",
      trust1: "Fast & reliable",
      trust2: "Personal advice",
      trust3: "Tailored solutions",
      whyTitle: "Why FeelAtHomeNow?",
      feature1Title: "Central locations",
      feature1Desc: "Apartments close to business centres and public transport.",
      feature2Title: "Flexible terms",
      feature2Desc: "From a few weeks to several years – we adapt to your needs.",
      feature3Title: "Full service",
      feature3Desc: "Furniture, setup, internet and all utilities included.",
      comfortTitle1: "A home for the time being.",
      comfortTitle2: "So your employees feel at home from day one.",
      comfortText: "We take care of everything so your employees feel at home right from the start.",
      comfortCta: "Learn more",
      formTitle: "Send inquiry",
      formText: "Tell us briefly about your needs – we will reply within 24 hours.",
      bottomTrust1: "Secure booking",
      bottomTrust2: "GDPR-compliant",
      bottomTrust3: "Personal support",
      bottomTrust4: "Proven service",
      imageAltHero: "Modern glass office building in the evening sun",
      imageAltLiving: "Bright living room with a lake view",
    },

    // Wohnungen landing (R5.4) — marketing page with real API listings
    wohnungenPage: {
      heroSubtitle: "Fully equipped apartments – all-inclusive, flexible terms and move-in ready. For expats, professionals and companies.",
      heroTrust1: "All-inclusive",
      heroTrust2: "Move in within 2h",
      heroTrust3: "Across Switzerland",
      infoCardTitle: "Comfortable living",
      infoCardText: "Furnished, central and move-in ready.",
      usp1Title: "Fully furnished",
      usp1Desc: "Move in and feel at home.",
      usp2Title: "Internet included",
      usp2Desc: "Wi-Fi in every apartment.",
      usp3Title: "Registration possible",
      usp3Desc: "We help you with the residence registration.",
      usp4Title: "Flexible rental terms",
      usp4Desc: "Cancel monthly or stay long-term.",
      usp5Title: "Personal service",
      usp5Desc: "We're here for you – fast and easy.",
      usp6Title: "For companies",
      usp6Desc: "Housing solutions for employees and teams.",
      listingsTitle: "Available apartments",
      emptyTitle: "No apartments available right now",
      emptyText: "Our apartments are often rented quickly. Get notified as soon as a suitable apartment becomes available.",
      emptyHint: "No spam. Unsubscribe anytime.",
      altTitle: "Popular alternatives",
      altText: "A room in a shared flat might be the right fit for you right now.",
      altCta: "Browse shared rooms",
      stepsTitle: "How it works",
      step1Title: "View",
      step1Desc: "Request a viewing in 30 seconds – on site or by video.",
      step2Title: "Apply",
      step2Desc: "Digitally, in just a few minutes.",
      step3Title: "Move in",
      step3Desc: "Pick up the keys – Wi-Fi's on, bed's ready, done.",
      trustBar1Title: "Secure booking",
      trustBar1Desc: "Verified apartments",
      trustBar2Title: "No hidden costs",
      trustBar2Desc: "Clear and transparent",
      trustBar3Title: "Personal support",
      trustBar3Desc: "Service that helps",
      trustBar4Title: "Verified listings",
      trustBar4Desc: "Real, vetted offers",
      imageAltHero: "Bright living room with a lake view",
      imageAltSessel: "Cosy armchair with a floor lamp",
    },

    // WG-Zimmer landing (R5.5) — designed page with real API listings
    zimmerPage: {
      heroTitlePre: "Find your ",
      heroTitleAccent: "home",
      heroTitlePost: " in Zurich",
      heroSubtitle: "Furnished rooms from 3 months – including internet, registration and an international community.",
      heroTrust1: "Fully furnished",
      heroTrust2: "Registration possible",
      heroTrust3: "Flexible rental terms",
      heroTrust4: "Video viewing",
      filterAria: "Filter rooms",
      filterCity: "City",
      filterPrice: "Price",
      filterAvailable: "Available from",
      filterSize: "Room size",
      filterReset: "Reset filters",
      cityAll: "All cities",
      priceAny: "Any",
      priceAsc: "Lowest first",
      priceDesc: "Highest first",
      availAny: "Any",
      availNow: "Available now",
      sizeAll: "All",
      sizeUnder15: "up to 15 m²",
      size15to20: "15–20 m²",
      sizeOver20: "over 20 m²",
      highlightBadge: "Available",
      highlightCta: "View now",
      gridLoadMore: "Load more rooms",
      whyTitle: "Why FeelAtHomeNow?",
      why1Title: "Prime locations in Zurich",
      why1Desc: "Central locations with great connections.",
      why2Title: "Registration possible",
      why2Desc: "We help you with the residence registration in Zurich.",
      why3Title: "Fully furnished",
      why3Desc: "Move in, feel at home, settle in.",
      why4Title: "International community",
      why4Desc: "Become part of an open and helpful community.",
      why5Title: "Flexible rental terms",
      why5Desc: "From 3 months – extend anytime.",
      why6Title: "Personal support",
      why6Desc: "Our team is here for you – before and after move-in.",
      bannerTitle: "Haven't found the right room yet?",
      bannerText: "We'll let you know straight away when a new room becomes available in Zurich.",
      bannerHint: "No obligation & unsubscribe anytime.",
      trustBar1: "Secure booking",
      trustBar2: "GDPR-compliant",
      trustBar3: "Personal support",
      trustBar4: "Proven service",
      imageAltHero: "Bright living room with a lake view",
    },

    // Homepage rebuild (R5.6) — new strings; listings/counts from the real API
    homePage: {
      heroSubtitle: "Fully equipped apartments – all-inclusive, flexible terms and move-in ready. For expats, professionals and companies.",
      infoCardTitle: "Comfortable living",
      infoCardText: "Furnished, central and move-in ready.",
      heroTrust1: "All-inclusive",
      heroTrust2: "Move in within 2h",
      heroTrust3: "Across Switzerland",
      heroTrust4: "Safe & vetted",
      usp1Title: "Fully furnished",
      usp1Desc: "Move in and feel at home.",
      usp2Title: "Internet included",
      usp2Desc: "Wi-Fi in every apartment.",
      usp3Title: "Registration possible",
      usp3Desc: "We help you with the registration.",
      usp4Title: "Flexible rental terms",
      usp4Desc: "Cancel monthly or stay long-term.",
      usp5Title: "Personal service",
      usp5Desc: "We're here for you – fast and easy.",
      usp6Title: "For companies",
      usp6Desc: "Housing solutions for employees and teams.",
      citiesTitle: "Popular cities",
      citiesViewAll: "View all cities",
      citySoon: "Coming soon",
      availableViewAll: "All apartments in Zurich",
      step1Title: "Search",
      step1Desc: "Find the right apartment for you – quick and easy.",
      step2Title: "Inquire",
      step2Desc: "Send a request in just a few minutes.",
      step3Title: "Move in",
      step3Desc: "Pick up the keys and feel right at home.",
      trustBar1Title: "Secure booking",
      trustBar1Desc: "Verified apartments",
      trustBar2Title: "Transparent prices",
      trustBar2Desc: "No hidden costs",
      trustBar3Title: "Personal service",
      trustBar3Desc: "We're here for you",
      trustBar4Title: "Verified apartments",
      trustBar4Desc: "Real, vetted listings",
      imageAltHero: "Bright living room with a lake view",
    },
    
    // For Property Managers Page
    propertyManagersPage: {
      title: 'For Property Managers',
      eyebrow: 'For Property Managers',
      heroLine1: 'Less vacancy.',
      heroLine2: 'Less effort.',
      heroLine3: 'Reliable tenants.',
      heroSubtitle:
        'We handle marketing, viewings, tenant screening and ongoing support – so your apartments stay occupied for the long term.',
      ctaPrimary: 'Become a partner',
      ctaSecondary: 'Book a free consultation',
      benefitsTitle: 'Your benefits at a glance',
      benefit1Title: 'Letting from a single source',
      benefit1Desc:
        'We take care of listings, viewings and all communication – efficiently and professionally.',
      benefit2Title: 'Screened tenants',
      benefit2Desc:
        'International professionals, expats and working tenants with stable income and a clean background.',
      benefit3Title: 'Specialised in fixed-term leases',
      benefit3Desc:
        'Our core expertise: fixed-term leases from 1 to 24 months – flexible, legally sound and predictable.',
      benefit4Title: 'Less vacancy',
      benefit4Desc:
        'Fast re-letting and continuous occupancy ensure predictable income.',
      partnerEyebrow: 'Your partner in Zurich',
      partnerTitle: 'Your letting partner with added value',
      partnerText:
        'We help owners and property managers increase the value of their properties – with a professional and personal service.',
      partnerCheck1: 'Professional marketing across all relevant channels',
      partnerCheck2: 'Careful tenant selection and credit checks',
      partnerCheck3: 'Viewings carried out on site or digitally',
      partnerCheck4: 'Contract handling and registration process',
      partnerCheck5: 'Support throughout the entire tenancy',
      partnerCheck6: 'Regular reports and transparent communication',
      partnerCta: 'Request a partnership',
      whyTitle: 'Why property managers work with FeelAtHomeNow',
      why1Title: 'Focus on long-term tenancies',
      why1Desc: 'Happy tenants, fewer turnovers, more stability.',
      why2Title: 'International professionals and expats',
      why2Desc: 'A target group with high reliability and appreciation.',
      why3Title: 'Specialised in the Zurich location',
      why3Desc: 'Local expertise and a strong network.',
      why4Title: 'A personal contact',
      why4Desc: 'Direct communication and fast decisions.',
      why5Title: 'Fast and efficient processes',
      why5Desc: 'From inquiry to move-in – without detours.',
      formTitle: "Let's talk about your property",
      formText:
        "Whether single apartments or entire properties – we're happy to explore a possible collaboration and put together a no-obligation concept for you.",
      formInquirySingle: 'Let a single apartment',
      formInquiryMultiple: 'Several apartments / building',
      formInquiryGeneral: 'General inquiry',
      imageAltHero: 'Modern residential complex in Zurich in the evening sun',
      imageAltBuilding: 'Apartment building along a street in Zurich',
    },
    
    // About Page v2 (R4.4) — story without unverifiable number claims (rule 14)
    aboutPage: {
      title: "About FeelAtHomeNow",
      subtitle: "We create a home for international professionals in Switzerland",
      storyEyebrow: "Our story",
      storyTitle: "At home in Zurich – for internationals, just like us.",
      story1: "FeelAtHomeNow was born from the idea of making it easier for international professionals, expats and students to settle in Switzerland. Especially in Zurich, finding suitable housing at short notice is hard – that is exactly where we come in.",
      story2: "We prepare every room so that all you need is your suitcase: furniture, Wi-Fi, utilities and registration – all included. Viewings happen on site or by video – even from abroad. Contracts are flexible with a minimum stay of 3 months.",
      story3: "Behind FeelAtHomeNow stands years of management experience and the ambition to offer not just accommodation but a real home away from home – with personal service and an international community where German and English are part of everyday life.",
      uspEyebrow: "Living with FeelAtHomeNow",
      uspTitle: "More than a room – a real home.",
      uspText: "Carefully chosen for you – from the fully furnished room to the international community:",
      uspItem1: "Fully furnished",
      uspItem2: "Registration possible",
      uspItem3: "International community",
      uspItem4: "Video viewing",
      uspCta: "View available rooms",
      valuesEyebrow: "Our values",
      valuesTitle: "What we stand for",
      value1Title: "A home for your stay",
      value1Desc: "Fully furnished rooms with everything you need to settle in.",
      value2Title: "International community",
      value2Desc: "Become part of an open community and make connections worldwide.",
      value3Title: "Prime locations in Zurich",
      value3Desc: "Central locations with great links to the city, university and work.",
      value4Title: "Registration possible",
      value4Desc: "We enable official residence registration – straightforward and legally sound.",
      value5Title: "Flexible & digital",
      value5Desc: "Viewings on site or by video – even from abroad.",
      imageAltHero: "Bright windowsill with a plant, books and a coffee cup",
      imageAltZimmer: "Furnished room with an orange bed",
      imageAltTerrasse: "Rooftop terrace with a lounge at sunset",
    },

    // Application Modal — full 5-step wizard
    application: {
      modal: {
        title: 'Application for Shared Room',
      },
      common: {
        back: 'Back',
        next: 'Next',
        submit: 'Submit Application',
        submitting: 'Sending…',
        stepOf: 'Step {n} of 5',
        stepAriaLabel: 'Step {n}: {label}',
        edit: 'Edit',
        editHint: 'Change via the steps above',
        selectPlaceholder: 'Please select…',
        yes: 'Yes',
        no: 'No',
        dash: '—',
      },
      steps: {
        personal: 'Personal',
        profession: 'Profession',
        finance: 'Finance',
        shared: 'Shared Living',
        documents: 'Documents',
      },
      errors: {
        required: 'Required',
        invalidValue: 'Invalid value',
        emailInvalid: 'Invalid email address',
        phoneInvalid: 'Invalid phone number',
        selectFromList: 'Please select from the list',
        firstAndLastName: 'Please enter first and last name',
        atLeastOneLanguage: 'Please select at least one language',
        pleaseExplain: 'Please briefly explain',
        maxChars: 'Max. {n} characters',
        pleaseProvideDuration: 'Please provide the duration',
        pleaseProvide: 'Please provide',
        pleaseConfirm: 'Please confirm',
        pleaseAccept: 'Please accept',
        idRequired: 'ID/Passport is required',
        fileType: 'Only PDF, JPG or PNG allowed',
        fileSize: 'File too large (max. 10 MB)',
        sendStatus: 'Error sending ({status})',
        sendGeneric: 'Could not send application. Please try again later.',
      },
      toast: {
        sent: 'Application sent',
      },
      files: {
        hint: 'PDF, JPG, PNG · max. 10 MB',
        select: 'Choose file',
        addReference: 'Add reference',
        remove: 'Remove',
      },
      langPicker: {
        add: 'Add languages...',
        search: 'Search language...',
        empty: 'No language found',
        removeAria: 'Remove {lang}',
      },
      step1: {
        applicantType: 'Applicant Type',
        applicantIndividual: 'Individual',
        applicantCompany: 'Company',
        companyName: 'Company Name',
        companyRegistrationNo: 'Commercial Register No. / UID',
        companyRegistrationPlaceholder: 'e.g. CHE-123.456.789',
        companyPosition: 'Position / Role',
        companyPositionPlaceholder: 'e.g. Managing Director',
        contactPerson: 'Contact Person Name',
        contactPersonPlaceholder: 'Full name',
        contactPersonHint: 'First and last name of the contact person',
        salutation: 'Salutation',
        salutationMr: 'Mr.',
        salutationMs: 'Ms.',
        salutationDiverse: 'Diverse',
        salutationNone: 'Prefer not to say',
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        phone: 'Phone',
        birthDate: 'Date of Birth',
        nationality: 'Nationality',
        nationalityPlaceholder: 'Enter or select country',
        residencePermit: 'Residence Permit',
        languages: 'Which languages do you speak?',
        addressStreet: 'Street and Number',
        addressZip: 'ZIP',
        addressCity: 'City',
        source: 'How did you hear about us?',
        sourceGoogle: 'Google / search engine',
        sourceFacebookInstagram: 'Facebook / Instagram',
        sourceDirectWebsite: 'Directly via the website',
        sourceReferral: 'Referral',
        sourceSonstiges: 'Other',
        sourceReferralLabel: 'Who referred you?',
        sourceReferralPlaceholder: 'Name of the person (optional)',
        sourceSonstigesLabel: 'Where exactly?',
        sourceSonstigesPlaceholder: 'Please describe briefly',
      },
      step2: {
        occupation: 'Occupation / Activity',
        occupationEmployed: 'Employed',
        occupationSelfEmployed: 'Self-employed',
        occupationStudent: 'Student',
        occupationApprentice: 'Apprentice',
        occupationJobSeeker: 'Job seeker',
        occupationRetiree: 'Retired',
        occupationOther: 'Other',
        occupationOtherSpecify: 'Please specify',
        employer: 'Employer / Company',
        grossIncome: 'Gross Monthly Income',
        workStyle: 'Work Mode',
        workStyleOffice: 'Office',
        workStyleHome: 'Home Office',
        workStyleHybrid: 'Hybrid',
        workStyleStudent: 'Student',
        moveInDate: 'Desired Move-in Date',
        rentDuration: 'Desired Rental Duration',
        rentDuration3m: '3 months',
        rentDuration6m: '6 months',
        rentDuration9m: '9 months',
        rentDuration12m: '12 months',
        rentDurationIndefinite: 'Indefinite',
        whoMovesIn: 'Who is moving in?',
        occupantName: 'Name of the person moving in',
        occupantNamePlaceholder: 'First and last name',
        occupantCount: 'Number of People',
        bookingFor: 'Booked for',
        bookingEmployee: 'Employee',
        bookingExpat: 'Expat',
        bookingConsultant: 'Consultant / Freelancer',
        bookingGuest: 'Guest / temporary staff',
        bookingOther: 'Other',
      },
      step3: {
        info: 'Your information is treated confidentially and used for credit assessment.',
        debtCollections: 'Debt collection proceedings in the last 24 months?',
        openCollections: 'Open debt collection proceedings?',
        lossCertificates: 'Any certificates of loss (Verlustscheine)?',
        financialNotes: 'Brief explanation',
      },
      step4: {
        wgExperience: 'Shared-living experience?',
        wgExperienceDuration: 'How long?',
        wgExperienceDurationPlaceholder: 'e.g. 2 years',
        dayRhythm: 'Daily Rhythm',
        dayRhythmEarlyBird: 'Early bird',
        dayRhythmNightOwl: 'Night owl',
        dayRhythmNormal: 'Normal',
        socialStyle: 'Social Style',
        socialStyleQuiet: 'Rather quiet',
        socialStyleSocial: 'Rather social',
        socialStyleBalanced: 'Balanced',
        smoker: 'Smoker?',
        cleanliness: 'Cleanliness & Tidiness',
        cleanlinessVeryImportant: 'Very important',
        cleanlinessImportant: 'Important',
        cleanlinessNormal: 'Normal',
        cleanlinessRelaxed: 'Rather relaxed',
        pets: 'Pets?',
        petsDetails: 'Which ones?',
        petsDetailsPlaceholder: 'e.g. 1 cat',
        visitors: 'Visitors / Parties',
        visitorsRare: 'Rarely',
        visitorsOccasional: 'Occasionally',
        visitorsOften: 'Often',
        wgRules: 'I am willing to follow the shared-living rules',
        selfDescription: 'Brief self-description as a flatmate',
        motivationRoom: 'Why this room?',
        motivationWg: 'Why shared living?',
      },
      step5: {
        documentsHeading: 'Documents',
        documentId: 'ID Copy / Passport',
        documentWorkContract: 'Employment Contract or Proof of Enrolment',
        documentDebtExtract: 'Debt Collection Extract (Betreibungsauszug)',
        documentReferences: 'Reference letters (multiple possible)',
        reviewHeading: 'Overview',
        reviewAddress: 'Address',
        reviewName: 'Name',
        reviewNationalityWithPermit: '{nationality} (Permit {permit})',
        reviewOccupantName: 'Person moving in',
        reviewOccupationOther: 'Other – {value}',
        reviewIncome: 'Income',
        reviewMoveIn: 'Move-in',
        reviewMietdauer: 'Rental Duration',
        reviewCompanyRegistration: 'Commercial Register / UID',
        reviewPosition: 'Position',
        reviewContactPerson: 'Contact Person',
        reviewSauberkeit: 'Cleanliness',
        consentsHeading: 'Optional Consents',
        consentCreditCheck: 'I consent that FeelAtHomeNow may obtain a credit check from a Swiss credit agency (e.g. CRIF, Intrum) to assess my ability to pay.',
        consentReferenceCheck: 'I consent that FeelAtHomeNow may obtain references from my previous landlord and/or employer.',
        consentOptional: '(Optional)',
        consentConfirmCorrect: 'I confirm that all information is truthful',
        privacyPrefix: 'I have read the ',
        privacyLink: 'Privacy Policy',
        privacySuffix: ' and consent to the processing of my data for the purpose of my application.',
      },
      success: {
        title: 'Thank you! Your application has been submitted.',
        subtitle: 'We have received your documents for {title}.',
        info24h: 'We will get back to you within 24 hours.',
        infoEmail: 'You will receive a confirmation by email.',
        close: 'Close',
      },
      apply: {
        seoTitle: 'Application',
        notAvailableTitle: 'This listing is no longer available',
        notAvailableBody: 'The listing you are looking for no longer exists or has been removed. Take a look at our current offers.',
        backToApartments: 'Back to all apartments',
        reapply: 'Apply again',
        chooseRoom: 'Choose your room',
        perMonth: '/month',
      },
    },
  },
};
